import { Share1Icon } from '@radix-ui/react-icons';
import { Text } from '@radix-ui/themes';
import { CommonTooltip } from 'components/common/tooltip';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IVideo } from 'lib_ts/interfaces/i-video';

export const VideoShareIcon = (props: { video: IVideo }) => {
  if (!props.video.original_id) {
    return null;
  }

  return (
    <CommonTooltip
      text="This video was shared with your team"
      trigger={
        <Text color={RADIX.COLOR.NEUTRAL}>
          <Share1Icon style={{ marginTop: RADIX.ICON.TABLE_MT }} />
        </Text>
      }
    />
  );
};
